// <copy-code data-code="..."> — copies the code to the clipboard when its
// [data-copy-trigger] button is clicked, with a short "copied" confirmation.
if (!customElements.get('copy-code')) {
  class CopyCode extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-copy-trigger]');
      if (!this.trigger) return;
      this.defaultLabel = this.trigger.textContent;
      this.trigger.addEventListener('click', () => this.copy());
    }

    disconnectedCallback() {
      clearTimeout(this.resetTimer);
    }

    copy() {
      const code = (this.getAttribute('data-code') || '').trim();
      if (!code) return;

      this.write(code);

      this.trigger.textContent = '¡Copiado!';
      this.trigger.classList.add('is-copied');
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        this.trigger.textContent = this.defaultLabel;
        this.trigger.classList.remove('is-copied');
      }, 2000);
    }

    write(code) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).catch(() => this.fallbackCopy(code));
      } else {
        this.fallbackCopy(code);
      }
    }

    fallbackCopy(code) {
      const temp = document.createElement('textarea');
      temp.value = code;
      temp.setAttribute('readonly', '');
      temp.style.position = 'absolute';
      temp.style.left = '-9999px';
      document.body.appendChild(temp);
      temp.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(temp);
    }
  }

  customElements.define('copy-code', CopyCode);
}
